import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { nodeApi, pythonApi } from './services/api/api'

export const store = configureStore({
  reducer: {
    [nodeApi.reducerPath]: nodeApi.reducer,
    [pythonApi.reducerPath]: pythonApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(nodeApi.middleware, pythonApi.middleware),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
